
//@ts-ignore
import NewChoiceSound from '~/static/sounds/sfx/nav_move.wav';
//@ts-ignore
import SelectSound from '~/static/sounds/sfx/cursor_selection_02.wav';
//@ts-ignore
import CloseSound from '~/static/sounds/sfx/cursor_click_01.wav';
//@ts-ignore
import ClickSound from '~/static/sounds/sfx/BSI_SFX_click_2.wav';
//@ts-ignore
import ConfirmSound from '~/static/sounds/sfx/BSI_SFX_confirm_2.wav';
const mode = process.env.NODE_ENV || 'development'

import core, { TeamObject, Player, EventSlot, EventRole, NodeEventRole, EventNode, ArrayObject, EventPlayer, TeamSlot } from '~/core';

import {flattenDeep} from 'lodash';

// let path = require('path');
export const ifDev = (fn: () => any) => {
	if (mode === 'development') {
		fn.call(this)
	}
}
export const ifProd = (fn: () => any) => {
	if (mode === 'production') {
		fn.call(this)
	}
}


export function log(...msg) {
	console.log(...msg);
}
export function trace(...msg) {
	console.trace(...msg);
}
export const prodLog = (...msg) => ({
	warn: (andProd=false) => {
		ifProd(() => {
			console.warn.call(msg, "🛠 Log: ", ...msg)
		})
		return prodLog;
	},
	info: (andProd=false) => {
		ifProd(() => {
			
			console.log.call(msg, "🛠 Log: ", ...msg)
		})
		return prodLog;
	},
	error: (andProd=false) => {
		ifProd(() => {
			console.error.call(msg, "🛠 Log: ", ...msg)
		})
		return prodLog;
	}

})

export const devLog = (...msg) => {
	// const fns = () => {

	// }
	const fns = Object(this)
	fns.warn = (andProd=false) => {
		ifDev(() => {
			console.warn.call(this, "🐜 Log: ", ...msg)
			andProd ? prodLog(...msg) : null
		})
		return devLog;
	}
	fns.info = (andProd=false) => {
		ifDev(() => {
			console.log.call(this, "🐜 Log: ", ...msg)
			//   
			andProd ? prodLog(...msg) : null
		})
		return devLog;
	}
	fns.error = (andProd=false) => {
		ifDev(() => {
			console.error.call(this, "🐜 Log: ", ...msg)
			andProd ? prodLog(...msg) : null
		})
		return devLog;
	}
	fns.succ = (andProd=false) => {
		ifDev(() => {
			console.log.call(this, "🐜 Log: %c","background: green; color: white;",  ...msg)
			andProd ? prodLog(...msg) : null
		})
		return devLog;
	}
	return <{info: (boolean?) => typeof devLog, error: (boolean?) => typeof devLog, warn: (boolean?) => typeof devLog, succ: (boolean?) => typeof devLog}>fns
}
// ({
// 	warn: (andProd=false) => {
// 		ifDev(() => {
// 			console.warn.call(msg, "🐜 Log: ", ...msg)
// 			andProd ? prodLog(...msg) : null
// 		})
// 		return devLog;
// 	},
// 	info: (andProd=false) => {
// 		ifDev(() => {
// 			console.log(this)
// 			console.log.call(msg, "🐜 Log: ", ...msg)
// 			andProd ? prodLog(...msg) : null
// 		})
// 		return devLog;
// 	},
// 	error: (andProd=false) => {
// 		ifDev(() => {
// 			console.error.call(msg, "🐜 Log: ", ...msg)
// 			andProd ? prodLog(...msg) : null
// 		})
// 		return devLog;
// 	}
	
// })
type Sound = any;
interface SFX {
	volume: number;
	create: Function;
	NewChoiceSound: Sound;
	SelectSound: Sound;
	CloseSound: Sound;
	ClickSound: Sound;
	ConfirmSound: Sound;
}

export const SFX = {
	NewChoiceSound,
	SelectSound,
	CloseSound,
	ClickSound,
	ConfirmSound,
	volume: 0.3,
	create(src: string): HTMLAudioElement|undefined{
		try{
			// path.parse(src);
			let audio = new Audio(src);
			audio.volume = this.volume;
			return audio;
		}
		catch(err){
			console.error(err);
			return undefined;
		}
	}
}
/**
 * 
 * @param array The array of objects to iterate through (must have the `prop` property as well as a property called `children`)
 * @param prop? Optional
 */
export function flattenByProp<T>(array: Array<ArrayObject>, prop?: string): Array<T> {
	let final: ArrayObject[] = [];
	if(prop){
		for (let el of array) {
			final.push(el[prop]);
			if (el.children && Array.isArray(el.children) && el.children.length > 0) final.push(flattenByProp(el.children, prop));
		}
	}
	else{
		for (let el of array) {
			final.push(el)
			if (el['children']) final.push(el['children']);
			if (el.children && Array.isArray(el.children) && el.children.length > 0) final.push(flattenByProp(el.children, undefined));
		}
	}
	
	return flattenDeep(final);
}
/**
 * A helper function that removes the items in an array that satisfy the predicate function in as sort a runtime as I could come up with O(n)
 * @param arr the array to remove the item from
 * @param predicate the function used to find the matching item
 */
export function removeFromArray<T>(arr: Array<T>, predicate: (item: T) => boolean): Array<T>{
	// console.log('removing element %o from array %o', predicate, arr)
	const newArray = Array.from(arr)
    const slotIndex = newArray.findIndex(predicate);
    console.log(slotIndex)
    if(slotIndex > -1){
        const half1 = newArray.slice(0, slotIndex)
        let half2 = []
        if(slotIndex+1 !== newArray.length) { half2.push(...newArray.slice(slotIndex+1)) }

        newArray.length = 0;

		newArray.push(...half1, ...half2);
		// console.log('new array!: ', newArray)
        return newArray;
    }else{
		return newArray;
	}
}

export namespace Events{
	export function createNodes(teams: TeamObject[], showSlots: boolean=false): Array<EventNode> {
		// console.log("%o", sections)
		
		let children: EventNode[] = [];
		for (let team of teams) {
			let slots: EventSlot[] = [];
			for(let slotId of team.slots){
				
				if(core.events.collection.selectors.focused.value.slots){
					
					const allSlots = core.events.collection.selectors.focused.value.slots
					let slot: TeamSlot|undefined = allSlots.find(slot => slot?.id === slotId)
					if(slot) slots.push(slot);
				}
			}
			
			

			let next_node: EventNode;
			let id = team.id;
			// id === section.id ? undefined : section.id = id; // if the id didn't exist to begin with, assign the new id to the property
			const players = findPlayersInSlots(team, core.events.collection.selectors.focused.value.players)
			next_node = {
				text: {
					name: team.name,
					"data-slots": "" + team.slots.length,
					desc:  team.slots.length?`${team.slots.length-(team.slots.length-players.length)}/${team.slots.length} Slot${team.slots.length == 1? '':'s'} Filled`:"",
				},
				stackChildren: true,
				HTMLid: `node-${id}`,
				HTMLclass: 'node-primary'
			};

			next_node.children = [];
			if (team.children !== null && team.children?.length > 0) {
				next_node.children = createNodes(team.children, showSlots);
			}
			else {
				next_node.stackChildren = true;
				next_node.collapsed = true;
				
			}
			// here, we push all of the slot nodes to the list (may remove)
			if(showSlots){
				next_node.children.push(
					...separateEventRoles(slots).map(role => ({
						text: {
							name: role.name,
							desc: role.slots + ` Slot${role.slots == 1? '':'s'}`,
							"data-parent": next_node.HTMLid
						},
						HTMLid: `node-${id}_${role.name.split(' ').join('')}`,
						HTMLclass: 'node-slot'
					}))
				);
			}
			
			children.push(next_node);

		}

		return children;

	}

	export function teamGroupFindId(id: number, structure: TeamObject[]): TeamObject|undefined {
		let found_group: TeamObject|undefined = undefined;
		for (let item of structure) {
			if (item.id === id) {
				found_group = item;
			};
			if (!found_group && item.children?.length > 0) found_group = teamGroupFindId(id, item.children);
		}
		return found_group;

	}
	export function findPlayersInSlots(group: TeamObject, players: EventPlayer[]): EventPlayer[] {
		let final_players: EventPlayer[] = [];
		for (let slotId of group.slots) {
			let _players = players.find(player => player.slotId === slotId);
			if (_players) final_players.push(_players); // If players is not undefined, push to final
		}
		// console.log()
		return final_players;

	}






	export function separateEventRoles(slots: TeamSlot[]): EventRole[] {
		let final_roles: EventRole[] = [];
		// loop though each slot
		for (let slot of slots) {
			
			let found: EventRole|undefined = final_roles.find(role => role.name === slot.role)
			if (found) {
				found.slots += 1;
			}
			else final_roles.push({ name: slot.role, slots: 1 })

		}
		return final_roles;

	}

	
}

export async function navSpacing(el: HTMLElement | undefined | null = undefined) {
	console.log('resizing the content.');
	let elem: HTMLElement | undefined | null = document.getElementById('master-content');
	// this function will dynamically set padding/margin based on the size of the nav bar (if it exists)
	// el is passed which is the element that you want the top margin to be applied to. this should be the component which houses the actual page content (ex. home)
	if (!elem){ 
		console.log('looking for content...');
		await new Promise((resolve, reject) => { setTimeout(resolve, 1000)})
		return navSpacing(elem);
	}

	if (document.getElementById('nav') && elem) {
		// we can only get in here is there exists an element with the id 'nav'
		var nav_height = document.getElementById('nav')?.offsetHeight;
		console.log(`Current nav height: ${nav_height}`);

		// if(el) el.setAttribute('style', `margin-top: ${nav_height}px;`) 
		elem?.setAttribute('style', `padding-top: ${nav_height}px;`);
		elem?.style.setProperty('--navHeight', nav_height + 'px');
		// done 😁
		return nav_height;
	}
}

export class Logger {
	groupName: string;
	constructor(name: string) {
		this.groupName = name;
	}
	start(){
		console.group(this.groupName);
		return this;
	}
	end(){
		console.groupEnd();
	}
	log(...message: any){
		console.log(...message);
		return this;
	}
	warn(...message: any) {
		console.warn(...message);
		return this;
	}
	error(message: string | Error) {
		if (typeof message === 'string') {
			// console.error(message);
		}
		console.error(message);
		return this;
	}
}